// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import {
    FeaturedCategoriesPayload,
    FeaturedCategoriesResponse,
    getFeaturedCategoriesData,
} from "@steiner/App/Services/FeaturedCategories";

type HandlerType = ApiHandler<FeaturedCategoriesPayload, FeaturedCategoriesResponse>;

export const SetLoading: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedCategories/setLoading",
        key: getDataViewKey(props.parameter),
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getFeaturedCategoriesData(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xFeaturedCategories/FailedLoad",
            key: getDataViewKey(props.apiParameter),
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadFeaturedCategoriesData: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedCategories/CompleteLoad",
        featuredCategoriesData: props.apiResult || [],
        key: getDataViewKey(props.apiParameter),
    } as any);
};

export const chain = [
    SetLoading,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadFeaturedCategoriesData,
];

const loadFeaturedCategories = createHandlerChainRunner(chain, "loadFeaturedCategories");

export default loadFeaturedCategories;
